module.exports = "pegasus_template/assets/tech/medium/5.jpg";